/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CorporateEntityService {
    /**
     * Create a new corporate entity
     * Creates a new corporate entity. Locations can be added separately using the location endpoint.
     * @param requestBody
     * @returns any Corporate entity created successfully
     * @throws ApiError
     */
    public static postApiV2CorporateEntity(
        requestBody: {
            /**
             * Legal name of the company
             */
            legal_name: string;
            /**
             * Company website URL (optional)
             */
            website?: string;
            /**
             * Contact phone number (optional)
             */
            phone?: string;
            /**
             * Company size category
             */
            size: 'MICRO' | 'SMALL' | 'MEDIUM' | 'LARGE' | 'ENTERPRISE';
            /**
             * Industry sector
             */
            industry: string;
            /**
             * Minimum Order Quantity (optional)
             */
            MOQ?: string;
            /**
             * Active status flag for the corporate entity (defaults to true if not provided)
             */
            activeflag?: boolean;
            /**
             * Buyer-specific profile information (optional)
             */
            buyerProfile?: {
                /**
                 * Additional industries the buyer is interested in
                 */
                industryInterests?: Array<string>;
                /**
                 * Annual procurement budget range
                 */
                budgetRange?: 'UNDER_10K' | 'K10_50K' | 'K50_100K' | 'K100_500K' | 'K500_1M' | 'OVER_1M';
                /**
                 * Criteria for preferred suppliers
                 */
                preferredSupplierCriteria?: {
                    /**
                     * Preferred supplier locations
                     */
                    preferredLocations?: Array<string>;
                    /**
                     * Required supplier certifications
                     */
                    requiredCertifications?: Array<string>;
                    /**
                     * Preferred supplier company size
                     */
                    preferredCompanySize?: 'MICRO' | 'SMALL' | 'MEDIUM' | 'LARGE' | 'ENTERPRISE';
                    /**
                     * Minimum years in business required
                     */
                    minimumYearsInBusiness?: number;
                };
                /**
                 * Typical order value range
                 */
                typicalOrderValue?: {
                    minimum?: number;
                    maximum?: number;
                    currency?: string;
                };
            };
        },
    ): CancelablePromise<{
        status?: boolean;
        message?: string;
        data?: {
            /**
             * The ID of the created corporate entity
             */
            cid?: number;
        };
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v2/corporate-entity',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                500: `Server error`,
            },
        });
    }
    /**
     * Get all corporate entities with optional filtering, search, pagination, and sorting
     * Retrieves corporate entities with their associated locations, industries, products, services, and certifications.
     * Supports comprehensive filtering, text search, pagination, and sorting.
     *
     * @param search Text search on legal name, website, and description (case-insensitive)
     * @param industry Filter by industry name
     * @param size Filter by company size
     * @param managerid Filter by manager ID
     * @param activeflag Filter by active status
     * @param publishStatus Filter by publish status
     * @param moq Filter by Minimum Order Quantity
     * @param productOrService Filter by product or service ID (searches both products and services through locations)
     * @param certificate Filter by certification ID (through locations)
     * @param country Filter by country code (e.g., 'US', 'CA')
     * @param page Page number (1-based, used with pageSize)
     * @param pageSize Number of results per page (used with page)
     * @param limit Maximum number of results to return (used with offset)
     * @param offset Number of results to skip (used with limit)
     * @param sort Sort field
     * @param order Sort order
     * @returns any Corporate entities retrieved successfully
     * @throws ApiError
     */
    public static getApiV2CorporateEntity(
        search?: string,
        industry?: string,
        size?: 'MICRO' | 'SMALL' | 'MEDIUM' | 'LARGE' | 'ENTERPRISE',
        managerid?: number,
        activeflag?: boolean,
        publishStatus?: string,
        moq?: string,
        productOrService?: number,
        certificate?: number,
        country?: string,
        page?: number,
        pageSize?: number,
        limit?: number,
        offset?: number,
        sort?: 'id' | 'legalname' | 'created' | 'updated' | 'industry' | 'size',
        order: 'asc' | 'desc' = 'asc',
    ): CancelablePromise<{
        status?: boolean;
        message?: string;
        data?: Array<{
            /**
             * Corporate entity ID
             */
            id?: number;
            /**
             * Manager user ID
             */
            managerid?: number;
            /**
             * Legal name of the company
             */
            legalname?: string;
            /**
             * Company website URL
             */
            website?: string | null;
            /**
             * Contact phone number
             */
            phone?: string | null;
            /**
             * Company size category
             */
            size?: string;
            /**
             * Industry sector
             */
            industry?: string;
            /**
             * Minimum Order Quantity
             */
            MOQ?: string | null;
            /**
             * Company email
             */
            email?: string | null;
            /**
             * Buyer-specific information (JSON object)
             */
            buyerProfile?: Record<string, any> | null;
            /**
             * Company description
             */
            description?: string | null;
            /**
             * Whether the entity is active
             */
            activeflag?: boolean | null;
            /**
             * Publish status
             */
            publish_status?: 'ZERO' | 'ONE';
            /**
             * Creation timestamp
             */
            created?: string | null;
            /**
             * Last update timestamp
             */
            updated?: string | null;
            /**
             * Vendor view count
             */
            vendor_view?: number | null;
            /**
             * Email receive count
             */
            email_receive_count?: number | null;
            location?: Array<{
                /**
                 * Location ID
                 */
                id?: number;
                /**
                 * Corporate entity ID
                 */
                cid?: number | null;
                /**
                 * Business function
                 */
                businessfunction?: string | null;
                /**
                 * Manager user ID
                 */
                managerid?: number;
                /**
                 * Two-letter country code
                 */
                country_code?: string;
                /**
                 * Street address
                 */
                address?: string;
                /**
                 * City name
                 */
                city?: string;
                /**
                 * State or province
                 */
                state?: string | null;
                /**
                 * Postal or ZIP code
                 */
                postal_code?: string | null;
                /**
                 * GPS coordinates
                 */
                gpscoordinates?: string | null;
                /**
                 * Creation timestamp
                 */
                created?: string | null;
                /**
                 * Last update timestamp
                 */
                updated?: string | null;
                locationProducts?: Array<{
                    /**
                     * Product ID
                     */
                    productId?: number;
                    /**
                     * Location ID
                     */
                    lid?: number;
                    /**
                     * Whether the location is buying this product
                     */
                    buying?: boolean;
                    /**
                     * Creation timestamp
                     */
                    created?: string | null;
                    product?: {
                        /**
                         * Product ID
                         */
                        id?: number;
                        /**
                         * Product category name
                         */
                        categoryname?: string;
                        /**
                         * Product item name
                         */
                        itemname?: string;
                        /**
                         * Whether the product is active
                         */
                        activeflag?: boolean | null;
                        /**
                         * Creation timestamp
                         */
                        created?: string | null;
                        /**
                         * Last update timestamp
                         */
                        updated?: string | null;
                    };
                }>;
                locationServices?: Array<{
                    /**
                     * Service ID
                     */
                    serviceId?: number;
                    /**
                     * Location ID
                     */
                    lid?: number;
                    /**
                     * Whether the location is buying this service
                     */
                    buying?: boolean;
                    /**
                     * Creation timestamp
                     */
                    created?: string | null;
                    service?: {
                        /**
                         * Service ID
                         */
                        id?: number;
                        /**
                         * Service category name
                         */
                        categoryname?: string;
                        /**
                         * Service item name
                         */
                        itemname?: string;
                        /**
                         * Whether the service is active
                         */
                        activeflag?: boolean | null;
                        /**
                         * Creation timestamp
                         */
                        created?: string | null;
                        /**
                         * Last update timestamp
                         */
                        updated?: string | null;
                    };
                }>;
                locationCertifications?: Array<{
                    /**
                     * Location ID
                     */
                    lid?: number;
                    /**
                     * Certification ID
                     */
                    certid?: number;
                    /**
                     * Year the certification was obtained
                     */
                    yearcertified?: number | null;
                    /**
                     * Creation timestamp
                     */
                    created?: string | null;
                    certification?: {
                        /**
                         * Certification ID
                         */
                        id?: number;
                        /**
                         * Certification name
                         */
                        certname?: string;
                        /**
                         * Certification category
                         */
                        certcategory?: string;
                        /**
                         * Certification tier
                         */
                        tier?: string | null;
                        /**
                         * Certification description
                         */
                        description?: string | null;
                        /**
                         * Whether the certification is verified
                         */
                        verified?: boolean | null;
                    };
                }>;
            }>;
            industries?: {
                /**
                 * Industry name
                 */
                indname?: string;
                /**
                 * Two-digit NAICS code
                 */
                naics_2?: string;
            };
        }>;
        /**
         * Pagination metadata (only present when pagination parameters are used)
         */
        pagination?: {
            /**
             * Current page number (when using page/pageSize)
             */
            page?: number;
            /**
             * Number of results per page (when using page/pageSize)
             */
            pageSize?: number;
            /**
             * Total number of pages (when using page/pageSize)
             */
            totalPages?: number;
            /**
             * Total number of results
             */
            total?: number;
            /**
             * Limit value (when using limit/offset)
             */
            limit?: number;
            /**
             * Offset value (when using limit/offset)
             */
            offset?: number;
        };
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v2/corporate-entity',
            query: {
                'search': search,
                'industry': industry,
                'size': size,
                'managerid': managerid,
                'activeflag': activeflag,
                'publish_status': publishStatus,
                'MOQ': moq,
                'productOrService': productOrService,
                'certificate': certificate,
                'country': country,
                'page': page,
                'pageSize': pageSize,
                'limit': limit,
                'offset': offset,
                'sort': sort,
                'order': order,
            },
            errors: {
                500: `Server error`,
            },
        });
    }
    /**
     * Get profile information for claiming (public)
     * Get profile information to display on claim page. No authentication required, but token must be valid.
     * @param id
     * @param token
     * @returns any Profile information retrieved
     * @throws ApiError
     */
    public static getApiV2CorporateEntityClaimInfo(
        id: number,
        token: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v2/corporate-entity/{id}/claim-info',
            path: {
                'id': id,
            },
            query: {
                'token': token,
            },
            errors: {
                400: `Invalid or expired token`,
                404: `Profile not found`,
            },
        });
    }
    /**
     * Create a location for a corporate entity
     * Creates a new location and associates it with an existing corporate entity
     * @param requestBody
     * @returns any Location created successfully
     * @throws ApiError
     */
    public static postApiV2CorporateEntityLocation(
        requestBody: {
            /**
             * Corporate entity ID (optional)
             */
            cid?: number;
            /**
             * Business function (optional)
             */
            businessfunction?: string;
            /**
             * Manager user ID
             */
            managerid: number;
            /**
             * Two-letter country code in uppercase
             */
            country_code: string;
            /**
             * Street address
             */
            address: string;
            /**
             * City name
             */
            city: string;
            /**
             * State or province (optional)
             */
            state?: string;
            /**
             * Postal or ZIP code (optional)
             */
            postal_code?: string;
            /**
             * GPS coordinates (optional)
             */
            gpscoordinates?: string;
        },
    ): CancelablePromise<{
        status?: boolean;
        message?: string;
        data?: {
            cid?: number;
            lid?: number;
        };
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v2/corporate-entity/location',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                500: `Server error`,
            },
        });
    }
    /**
     * Get a corporate entity by ID
     * Retrieves a corporate entity with its associated locations and industries
     * @param id Corporate entity ID
     * @returns any Corporate entity retrieved successfully
     * @throws ApiError
     */
    public static getApiV2CorporateEntity1(
        id: number,
    ): CancelablePromise<{
        status?: boolean;
        message?: string;
        data?: {
            /**
             * Corporate entity ID
             */
            id?: number;
            /**
             * Manager user ID
             */
            managerid?: number;
            /**
             * Legal name of the company
             */
            legalname?: string;
            /**
             * Company website URL
             */
            website?: string | null;
            /**
             * Contact phone number
             */
            phone?: string | null;
            /**
             * Company size category
             */
            size?: string;
            /**
             * Industry sector
             */
            industry?: string;
            /**
             * Minimum Order Quantity
             */
            MOQ?: string | null;
            /**
             * Company email
             */
            email?: string | null;
            /**
             * Buyer-specific information (JSON object)
             */
            buyerProfile?: Record<string, any> | null;
            /**
             * Company description
             */
            description?: string | null;
            /**
             * Whether the entity is active
             */
            activeflag?: boolean | null;
            /**
             * Publish status
             */
            publish_status?: 'ZERO' | 'ONE';
            /**
             * Creation timestamp
             */
            created?: string | null;
            /**
             * Last update timestamp
             */
            updated?: string | null;
            /**
             * Vendor view count
             */
            vendor_view?: number | null;
            /**
             * Email receive count
             */
            email_receive_count?: number | null;
            location?: Array<{
                /**
                 * Location ID
                 */
                id?: number;
                /**
                 * Corporate entity ID
                 */
                cid?: number | null;
                /**
                 * Business function
                 */
                businessfunction?: string | null;
                /**
                 * Manager user ID
                 */
                managerid?: number;
                /**
                 * Two-letter country code
                 */
                country_code?: string;
                /**
                 * Street address
                 */
                address?: string;
                /**
                 * City name
                 */
                city?: string;
                /**
                 * State or province
                 */
                state?: string | null;
                /**
                 * Postal or ZIP code
                 */
                postal_code?: string | null;
                /**
                 * GPS coordinates
                 */
                gpscoordinates?: string | null;
                /**
                 * Creation timestamp
                 */
                created?: string | null;
                /**
                 * Last update timestamp
                 */
                updated?: string | null;
                locationProducts?: Array<{
                    /**
                     * Product ID
                     */
                    productId?: number;
                    /**
                     * Location ID
                     */
                    lid?: number;
                    /**
                     * Whether the location is buying this product
                     */
                    buying?: boolean;
                    /**
                     * Creation timestamp
                     */
                    created?: string | null;
                    product?: {
                        /**
                         * Product ID
                         */
                        id?: number;
                        /**
                         * Product category name
                         */
                        categoryname?: string;
                        /**
                         * Product item name
                         */
                        itemname?: string;
                        /**
                         * Whether the product is active
                         */
                        activeflag?: boolean | null;
                        /**
                         * Creation timestamp
                         */
                        created?: string | null;
                        /**
                         * Last update timestamp
                         */
                        updated?: string | null;
                    };
                }>;
                locationServices?: Array<{
                    /**
                     * Service ID
                     */
                    serviceId?: number;
                    /**
                     * Location ID
                     */
                    lid?: number;
                    /**
                     * Whether the location is buying this service
                     */
                    buying?: boolean;
                    /**
                     * Creation timestamp
                     */
                    created?: string | null;
                    service?: {
                        /**
                         * Service ID
                         */
                        id?: number;
                        /**
                         * Service category name
                         */
                        categoryname?: string;
                        /**
                         * Service item name
                         */
                        itemname?: string;
                        /**
                         * Whether the service is active
                         */
                        activeflag?: boolean | null;
                        /**
                         * Creation timestamp
                         */
                        created?: string | null;
                        /**
                         * Last update timestamp
                         */
                        updated?: string | null;
                    };
                }>;
                locationCertifications?: Array<{
                    /**
                     * Location ID
                     */
                    lid?: number;
                    /**
                     * Certification ID
                     */
                    certid?: number;
                    /**
                     * Year the certification was obtained
                     */
                    yearcertified?: number | null;
                    /**
                     * Creation timestamp
                     */
                    created?: string | null;
                    certification?: {
                        /**
                         * Certification ID
                         */
                        id?: number;
                        /**
                         * Certification name
                         */
                        certname?: string;
                        /**
                         * Certification category
                         */
                        certcategory?: string;
                        /**
                         * Certification tier
                         */
                        tier?: string | null;
                        /**
                         * Certification description
                         */
                        description?: string | null;
                        /**
                         * Whether the certification is verified
                         */
                        verified?: boolean | null;
                    };
                }>;
            }>;
            industries?: {
                /**
                 * Industry name
                 */
                indname?: string;
                /**
                 * Two-digit NAICS code
                 */
                naics_2?: string;
            };
        };
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v2/corporate-entity/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation error`,
                404: `Corporate entity not found`,
                500: `Server error`,
            },
        });
    }
    /**
     * Update a corporate entity
     * Updates a corporate entity. Only the fields provided in the request body will be updated.
     * The user must be the manager (owner) of the corporate entity.
     *
     * @param id Corporate entity ID
     * @param requestBody
     * @returns any Corporate entity updated successfully
     * @throws ApiError
     */
    public static patchApiV2CorporateEntity(
        id: number,
        requestBody: {
            /**
             * Legal name of the company
             */
            legal_name?: string;
            /**
             * Company website URL
             */
            website?: string;
            /**
             * Contact phone number
             */
            phone?: string;
            /**
             * Company size category
             */
            size?: 'MICRO' | 'SMALL' | 'MEDIUM' | 'LARGE' | 'ENTERPRISE';
            /**
             * Industry sector
             */
            industry?: string;
            /**
             * Minimum Order Quantity
             */
            MOQ?: string;
            /**
             * Buyer-specific profile information
             */
            buyerProfile?: {
                industryInterests?: Array<string>;
                budgetRange?: 'UNDER_10K' | 'K10_50K' | 'K50_100K' | 'K100_500K' | 'K500_1M' | 'OVER_1M';
                preferredSupplierCriteria?: {
                    preferredLocations?: Array<string>;
                    requiredCertifications?: Array<string>;
                    preferredCompanySize?: 'MICRO' | 'SMALL' | 'MEDIUM' | 'LARGE' | 'ENTERPRISE';
                    minimumYearsInBusiness?: number;
                };
                typicalOrderValue?: {
                    minimum?: number;
                    maximum?: number;
                    currency?: string;
                };
            };
            /**
             * Company description
             */
            description?: string;
            /**
             * Active status flag
             */
            activeflag?: boolean;
        },
    ): CancelablePromise<{
        status?: boolean;
        message?: string;
        data?: {
            /**
             * Corporate entity ID
             */
            id?: number;
            /**
             * Manager user ID
             */
            managerid?: number;
            /**
             * Legal name of the company
             */
            legalname?: string;
            /**
             * Company website URL
             */
            website?: string | null;
            /**
             * Contact phone number
             */
            phone?: string | null;
            /**
             * Company size category
             */
            size?: string;
            /**
             * Industry sector
             */
            industry?: string;
            /**
             * Minimum Order Quantity
             */
            MOQ?: string | null;
            /**
             * Company email
             */
            email?: string | null;
            /**
             * Buyer-specific information (JSON object)
             */
            buyerProfile?: Record<string, any> | null;
            /**
             * Company description
             */
            description?: string | null;
            /**
             * Whether the entity is active
             */
            activeflag?: boolean | null;
            /**
             * Publish status
             */
            publish_status?: 'ZERO' | 'ONE';
            /**
             * Creation timestamp
             */
            created?: string | null;
            /**
             * Last update timestamp
             */
            updated?: string | null;
            /**
             * Vendor view count
             */
            vendor_view?: number | null;
            /**
             * Email receive count
             */
            email_receive_count?: number | null;
            location?: Array<{
                /**
                 * Location ID
                 */
                id?: number;
                /**
                 * Corporate entity ID
                 */
                cid?: number | null;
                /**
                 * Business function
                 */
                businessfunction?: string | null;
                /**
                 * Manager user ID
                 */
                managerid?: number;
                /**
                 * Two-letter country code
                 */
                country_code?: string;
                /**
                 * Street address
                 */
                address?: string;
                /**
                 * City name
                 */
                city?: string;
                /**
                 * State or province
                 */
                state?: string | null;
                /**
                 * Postal or ZIP code
                 */
                postal_code?: string | null;
                /**
                 * GPS coordinates
                 */
                gpscoordinates?: string | null;
                /**
                 * Creation timestamp
                 */
                created?: string | null;
                /**
                 * Last update timestamp
                 */
                updated?: string | null;
                locationProducts?: Array<{
                    /**
                     * Product ID
                     */
                    productId?: number;
                    /**
                     * Location ID
                     */
                    lid?: number;
                    /**
                     * Whether the location is buying this product
                     */
                    buying?: boolean;
                    /**
                     * Creation timestamp
                     */
                    created?: string | null;
                    product?: {
                        /**
                         * Product ID
                         */
                        id?: number;
                        /**
                         * Product category name
                         */
                        categoryname?: string;
                        /**
                         * Product item name
                         */
                        itemname?: string;
                        /**
                         * Whether the product is active
                         */
                        activeflag?: boolean | null;
                        /**
                         * Creation timestamp
                         */
                        created?: string | null;
                        /**
                         * Last update timestamp
                         */
                        updated?: string | null;
                    };
                }>;
                locationServices?: Array<{
                    /**
                     * Service ID
                     */
                    serviceId?: number;
                    /**
                     * Location ID
                     */
                    lid?: number;
                    /**
                     * Whether the location is buying this service
                     */
                    buying?: boolean;
                    /**
                     * Creation timestamp
                     */
                    created?: string | null;
                    service?: {
                        /**
                         * Service ID
                         */
                        id?: number;
                        /**
                         * Service category name
                         */
                        categoryname?: string;
                        /**
                         * Service item name
                         */
                        itemname?: string;
                        /**
                         * Whether the service is active
                         */
                        activeflag?: boolean | null;
                        /**
                         * Creation timestamp
                         */
                        created?: string | null;
                        /**
                         * Last update timestamp
                         */
                        updated?: string | null;
                    };
                }>;
                locationCertifications?: Array<{
                    /**
                     * Location ID
                     */
                    lid?: number;
                    /**
                     * Certification ID
                     */
                    certid?: number;
                    /**
                     * Year the certification was obtained
                     */
                    yearcertified?: number | null;
                    /**
                     * Creation timestamp
                     */
                    created?: string | null;
                    certification?: {
                        /**
                         * Certification ID
                         */
                        id?: number;
                        /**
                         * Certification name
                         */
                        certname?: string;
                        /**
                         * Certification category
                         */
                        certcategory?: string;
                        /**
                         * Certification tier
                         */
                        tier?: string | null;
                        /**
                         * Certification description
                         */
                        description?: string | null;
                        /**
                         * Whether the certification is verified
                         */
                        verified?: boolean | null;
                    };
                }>;
            }>;
            industries?: {
                /**
                 * Industry name
                 */
                indname?: string;
                /**
                 * Two-digit NAICS code
                 */
                naics_2?: string;
            };
        };
    }> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v2/corporate-entity/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                403: `User does not have permission to update this corporate entity`,
                404: `Corporate entity not found`,
                500: `Server error`,
            },
        });
    }
    /**
     * Get social media accounts for a corporate entity
     * Retrieves all social media accounts associated with a corporate entity
     * @param id Corporate entity ID
     * @returns any Social media accounts retrieved successfully
     * @throws ApiError
     */
    public static getApiV2CorporateEntitySocialMedia(
        id: number,
    ): CancelablePromise<{
        status?: boolean;
        message?: string;
        data?: Array<{
            id?: number;
            cid?: number;
            handle?: string;
            /**
             * Platform name (e.g., facebook, twitter, instagram, etc.)
             */
            platform?: string;
        }>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v2/corporate-entity/{id}/social-media',
            path: {
                'id': id,
            },
            errors: {
                403: `User does not have permission to view this corporate entity`,
                404: `Corporate entity not found`,
            },
        });
    }
    /**
     * Create or update social media accounts for a corporate entity
     * Creates or updates social media accounts for a corporate entity.
     * Replaces all existing social media accounts with the new ones.
     *
     * **Platforms:**
     * - Any platform name is allowed (max 50 characters, alphanumeric with spaces, underscores, and hyphens)
     * - Platform names are case-insensitive
     * - Examples: facebook, twitter, instagram, linkedin, youtube, tiktok, wechat, threads, "new platform", etc.
     *
     * **Example:**
     * ```json
     * {
         * "accounts": {
             * "facebook": "companypage",
             * "twitter": "@company",
             * "linkedin": "company-name"
             * }
             * }
             * ```
             *
             * **Note:** To delete all social media accounts, send an empty object or omit the accounts field.
             *
             * @param id Corporate entity ID
             * @param requestBody
             * @returns any Social media accounts updated successfully
             * @throws ApiError
             */
            public static postApiV2CorporateEntitySocialMedia(
                id: number,
                requestBody?: {
                    /**
                     * Object mapping platform names to handles
                     */
                    accounts?: Record<string, string>;
                },
            ): CancelablePromise<{
                status?: boolean;
                message?: string;
                data?: Array<{
                    id?: number;
                    cid?: number;
                    handle?: string;
                    platform?: string;
                }>;
            }> {
                return __request(OpenAPI, {
                    method: 'POST',
                    url: '/api/v2/corporate-entity/{id}/social-media',
                    path: {
                        'id': id,
                    },
                    body: requestBody,
                    mediaType: 'application/json',
                    errors: {
                        400: `Validation error`,
                        403: `User does not have permission to update this corporate entity`,
                        404: `Corporate entity not found`,
                    },
                });
            }
            /**
             * Delete all social media accounts for a corporate entity
             * Deletes all social media accounts associated with a corporate entity
             * @param id Corporate entity ID
             * @returns any Social media accounts deleted successfully
             * @throws ApiError
             */
            public static deleteApiV2CorporateEntitySocialMedia(
                id: number,
            ): CancelablePromise<{
                status?: boolean;
                message?: string;
                data?: Record<string, any> | null;
            }> {
                return __request(OpenAPI, {
                    method: 'DELETE',
                    url: '/api/v2/corporate-entity/{id}/social-media',
                    path: {
                        'id': id,
                    },
                    errors: {
                        403: `User does not have permission to delete social media for this corporate entity`,
                        404: `Corporate entity not found`,
                    },
                });
            }
            /**
             * Get matches for a corporate entity
             * Retrieves matched corporate entities for the specified corporate entity.
             * For buyers, returns suppliers who meet their requirements.
             * For suppliers, returns buyers who need what they offer.
             * Matches are computed by a background job and stored in the matches table.
             *
             * @param id Corporate entity ID
             * @returns any Matches retrieved successfully
             * @throws ApiError
             */
            public static getApiV2CorporateEntityMatches(
                id: number,
            ): CancelablePromise<{
                status?: boolean;
                message?: string;
                data?: Array<{
                    /**
                     * Matched corporate entity ID
                     */
                    id?: number;
                    /**
                     * Legal name of the matched entity
                     */
                    legalname?: string;
                    website?: string | null;
                    phone?: string | null;
                    size?: string;
                    industry?: string;
                    description?: string | null;
                    location?: Array<{
                        /**
                         * Location ID
                         */
                        id?: number;
                        /**
                         * Corporate entity ID
                         */
                        cid?: number | null;
                        /**
                         * Business function
                         */
                        businessfunction?: string | null;
                        /**
                         * Manager user ID
                         */
                        managerid?: number;
                        /**
                         * Two-letter country code
                         */
                        country_code?: string;
                        /**
                         * Street address
                         */
                        address?: string;
                        /**
                         * City name
                         */
                        city?: string;
                        /**
                         * State or province
                         */
                        state?: string | null;
                        /**
                         * Postal or ZIP code
                         */
                        postal_code?: string | null;
                        /**
                         * GPS coordinates
                         */
                        gpscoordinates?: string | null;
                        /**
                         * Creation timestamp
                         */
                        created?: string | null;
                        /**
                         * Last update timestamp
                         */
                        updated?: string | null;
                        locationProducts?: Array<{
                            /**
                             * Product ID
                             */
                            productId?: number;
                            /**
                             * Location ID
                             */
                            lid?: number;
                            /**
                             * Whether the location is buying this product
                             */
                            buying?: boolean;
                            /**
                             * Creation timestamp
                             */
                            created?: string | null;
                            product?: {
                                /**
                                 * Product ID
                                 */
                                id?: number;
                                /**
                                 * Product category name
                                 */
                                categoryname?: string;
                                /**
                                 * Product item name
                                 */
                                itemname?: string;
                                /**
                                 * Whether the product is active
                                 */
                                activeflag?: boolean | null;
                                /**
                                 * Creation timestamp
                                 */
                                created?: string | null;
                                /**
                                 * Last update timestamp
                                 */
                                updated?: string | null;
                            };
                        }>;
                        locationServices?: Array<{
                            /**
                             * Service ID
                             */
                            serviceId?: number;
                            /**
                             * Location ID
                             */
                            lid?: number;
                            /**
                             * Whether the location is buying this service
                             */
                            buying?: boolean;
                            /**
                             * Creation timestamp
                             */
                            created?: string | null;
                            service?: {
                                /**
                                 * Service ID
                                 */
                                id?: number;
                                /**
                                 * Service category name
                                 */
                                categoryname?: string;
                                /**
                                 * Service item name
                                 */
                                itemname?: string;
                                /**
                                 * Whether the service is active
                                 */
                                activeflag?: boolean | null;
                                /**
                                 * Creation timestamp
                                 */
                                created?: string | null;
                                /**
                                 * Last update timestamp
                                 */
                                updated?: string | null;
                            };
                        }>;
                        locationCertifications?: Array<{
                            /**
                             * Location ID
                             */
                            lid?: number;
                            /**
                             * Certification ID
                             */
                            certid?: number;
                            /**
                             * Year the certification was obtained
                             */
                            yearcertified?: number | null;
                            /**
                             * Creation timestamp
                             */
                            created?: string | null;
                            certification?: {
                                /**
                                 * Certification ID
                                 */
                                id?: number;
                                /**
                                 * Certification name
                                 */
                                certname?: string;
                                /**
                                 * Certification category
                                 */
                                certcategory?: string;
                                /**
                                 * Certification tier
                                 */
                                tier?: string | null;
                                /**
                                 * Certification description
                                 */
                                description?: string | null;
                                /**
                                 * Whether the certification is verified
                                 */
                                verified?: boolean | null;
                            };
                        }>;
                    }>;
                    industries?: {
                        /**
                         * Industry name
                         */
                        indname?: string;
                        /**
                         * Two-digit NAICS code
                         */
                        naics_2?: string;
                    };
                    /**
                     * Match score (0-100)
                     */
                    matchScore?: number;
                    /**
                     * Reason for the match
                     */
                    matchReason?: string;
                    updated?: string;
                }>;
            }> {
                return __request(OpenAPI, {
                    method: 'GET',
                    url: '/api/v2/corporate-entity/{id}/matches',
                    path: {
                        'id': id,
                    },
                    errors: {
                        404: `Corporate entity not found`,
                        500: `Server error`,
                    },
                });
            }
            /**
             * Claim a corporate entity profile
             * Authenticated user can claim a profile using a valid claim token
             * @param id
             * @param requestBody
             * @returns any Profile claimed successfully
             * @throws ApiError
             */
            public static postApiV2CorporateEntityClaim(
                id: number,
                requestBody: {
                    /**
                     * The claim token provided in the invitation
                     */
                    claim_token: string;
                    /**
                     * Optional. Set if the user is claiming as a Buyer or Supplier (used for onboarding).
                     */
                    userType?: 'BUYER' | 'SUPPLIER';
                },
            ): CancelablePromise<any> {
                return __request(OpenAPI, {
                    method: 'POST',
                    url: '/api/v2/corporate-entity/{id}/claim',
                    path: {
                        'id': id,
                    },
                    body: requestBody,
                    mediaType: 'application/json',
                    errors: {
                        400: `Invalid or expired token`,
                        403: `Profile already claimed or token invalid`,
                        404: `Profile not found`,
                    },
                });
            }
        }
